<template>
  <div>
    <b-modal id="productConfiguration" title="Product Setting" size="lg">

      <template #modal-header>
        <div class="d-flex w-100 justify-content-left h2 text-primary">
          Product Setting
        </div>
      </template>

      <div class="d-flex flex-column w-100">

        <div class="form-group">
          <label class="form-label">Outlet</label>
          <multiselect
            v-model="selectedOutlet"
            label="text"
            track-by="id"
            :options="outlets"
            :searchable="false"
            :show-labels="false"
            openDirection="below">
            <template slot="option" slot-scope="{ option }">{{ option.text }}</template>
          </multiselect>
        </div>

        <div class="panel-container">

          <div class="panel-content">

            <!-- <ul class="nav nav-tabs" role="tablist">
              <li class="nav-item" v-for="c of sections" :key="'section' + c.sectionID">
                <a :class="{ 'active': selectedSection['sectionID'] === c.sectionID }" class="nav-link" role="tab" @click="filterBySection(c)">
                  {{ c.name }}
                </a>
              </li>
            </ul>

            <table class="table">
              <tr>
                <th>Product</th>
                <th style="text-align: center">Commission</th>
                <th style="text-align: center">Sharing / Not Sharing</th>
              </tr>
              <tr>
                <td :colspan="3"><h6>Category</h6></td>
              </tr>
              <tr>
                <td>
                  <label class="form-label"><u>{{ selectedSection['name'] }}</u></label>
                </td>
                <td>
                  <select
                    class="form-control"
                    v-model="comm[selectedSection['sectionID']]"
                    type="number"
                    :searchable="false"
                    :show-labels="false">
                    <option value="5%">5%</option>
                    <option value="10%">10%</option>
                    <option value="50%">50%</option>
                  </select>
                </td>
                <td style="text-align: center; vertical-align: middle">
                  <input
                    v-model="share[selectedSection['sectionID']]"
                    type="checkbox"
                    :searchable="false"
                    :show-labels="false"
                    @change="sectionShareChange(selectedSection['sectionID'])" />
                </td>
              </tr>
              <tr>
                <td :colspan="3"><h6>Product List</h6></td>
              </tr>
              <tr v-for="(product, index) in selectedProducts" :key="'product_' + index">
                <td>
                  <label class="form-label">{{ product['name'] }}</label>
                </td>
                <td>
                  <select
                    class="form-control"
                    v-model="comm[product['id']]"
                    type="number"
                    :searchable="false"
                    :show-labels="false">
                    <option value="5%">5%</option>
                    <option value="10%">10%</option>
                    <option value="50%">50%</option>
                  </select>
                </td>
                <td style="text-align: center; vertical-align: middle">
                  <input
                    v-model="share[product['id']]"
                    type="checkbox"
                    :searchable="false"
                    :show-labels="false" />
                </td>
              </tr>
            </table> -->

            <table class="table">
              <tr>
                <th>Product Category</th>
                <th style="text-align: center">Commission</th>
              </tr>
              <tr v-for="c of sections" :key="'section' + c.sectionID">
                <td style="min-width: 200px">{{ c['name'] }}</td>

                <td style="min-width: 200px">
                  <select
                    class="form-control"
                    v-model="comm[c['sectionID']]"
                    type="number"
                    :searchable="false"
                    :show-labels="false">
                    <option value="5%">5%</option>
                    <option value="10%">10%</option>
                    <option value="50%">50%</option>
                  </select>
                </td>

                <td style="min-width: 200px" v-for="(item, index) of staffCustomize[c['sectionID']]" :key="'customize_' + index">
                  
                  <div class="row">

                    <div class="col-9 p-0">
                      <select
                        class="form-control"
                        v-model="item['staff']"
                        :searchable="false"
                        :show-labels="false">
                        <option v-for="(staff, index) of selectableStaff" :value="staff['staffID']" :key="'customize_staff' + index">{{ staff['name'] }}</option>
                      </select>

                      <select
                        class="form-control"
                        v-model="item['comm']"
                        :searchable="false"
                        :show-labels="false">
                        <option value="5%">5%</option>
                        <option value="10%">10%</option>
                        <option value="50%">50%</option>
                      </select>
                    </div>

                    <div class="col-3 p-0" style="vertical-align: middle">
                      <button type="button" class="btn btn-danger" @click="removeCustomize(c['sectionID'], index)">X</button>
                    </div>

                  </div>

                </td>

                <td>
                  <button type="button" class="btn btn-primary" @click="addCustomize(c['sectionID'])">+</button>
                </td>

              </tr>
            </table>

          </div>

        </div>
      </div>

      <template #modal-footer="{ close }">
        <div class="d-flex w-100 justify-content-end">
          <b-button @click="close()" class="mr-1">Cancel</b-button>
          <b-button variant="primary" @click="save()">OK</b-button>
        </div>
      </template>

    </b-modal>

  </div>
</template>
<script>
import moment from 'moment'
import { calculateSalesReportTotal, getSubTotal } from '@/assets/js/dashboard/salonReport/salonReport.js'
import { getOutletName, handleSessionExpired } from '@/assets/js/dashboard/dashboard.js'
import { formatPrice, insertLeadingZero } from '@/assets/js/dashboard/utilities.js'
export default {
  name: "productConfiguration",
  data() {
    return {
      showLoading: false,
      outlets: [],
      sections: [],
      selectedSection: {},
      products: [],
      selectedProducts: [],
      staffs: [],

      selectedOutlet: {},
      comm: {},
      share: {},
      staffCustomize: {},
      selectableStaff: [],
    }
  },
  watch: {
    selectedOutlet(val) {
      this.onOutletChange()
    }
  },
  methods: {
    open() {
      this.$bvModal.show('productConfiguration')
      this.loadSection()
    },

    onOutletChange() {
      this.comm = {}
      this.share = {}
      this.selectableStaff = this.staffs.filter(k => k['outletID'] == this.selectedOutlet.id)
      this.loadCommission()
    },

    filterBySection(val) {
      this.selectedSection = val
      this.selectedProducts.splice(0, this.selectedProducts.length)

      for (let product of this.products) {
        if(product['section']['sectionID'] === 0) {
          product['section']['sectionID'] = this.sections[0]['sectionID']
        }
        if (product['section']['sectionID'] === this.selectedSection['sectionID']) {
          this.selectedProducts.push({ id: product['skuID'], name: product['name'] })
        }
      }
    },

    loadSection() {
      this.showLoading = true

      this.$axios({
        method: 'get',
        url: 'https://menu.tunai.io/business/sections?typeID=2',
        headers: { token: this.$util.getSessionToken() }
      })
        .then((response) => {
          this.showLoading = false
          this.sections = response.data.sections
          this.selectedSection = this.sections[0]

          this.loadProduct()
        })
        .catch((err) => {
          this.showLoading = false

          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        })
    },
    loadProduct() {
      this.showLoading = true

      this.$axios({
        method: 'get',
        url: 'https://menu.tunai.io/business/sku?typeID=2&enable=1',
        headers: { token: this.$util.getSessionToken() }
      })
        .then((response) => {
          this.showLoading = false
          this.products = response.data.skus
          this.filterBySection(this.selectedSection)
          this.loadStaff()
        })
        .catch((err) => {
          this.showLoading = false

          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        })
    },

    loadStaff() {
      this.showLoading = true

      this.$axios({
        method: 'get',
        url: 'https://staff.tunai.io/business/staff',
        headers: { token: this.$util.getSessionToken() }
      })
        .then((response) => {
          this.showLoading = false
          this.staffs = response.data.staffs
          this.onOutletChange()
        })
        .catch((err) => {
          this.showLoading = false

          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }

          this.loadCommission()
        })
    },
    loadCommission() {
      this.showLoading = true

      let url = `https://emerchant.tunai.io/setting2.php/${this.selectedOutlet.text}_TheNailEdge_fixedCommission_product_setting`
      if (window.location.href.includes('localhost') || window.location.href.includes('127.0.0.1')) {
        url = `http://localhost:8080/setting2.php/${this.selectedOutlet.text}_TheNailEdge_fixedCommission_product_setting`
      }

      this.$axios({
        method: 'get',
        url: url,
        // headers: { token: this.$util.getSessionToken() }
      })
        .then((response) => {
          this.showLoading = false

          this.staffCustomize = {}
          for(let section of this.sections) {
            this.staffCustomize[section['sectionID']] = []
          }

          for (let temp in response.data) {
            let setting = (response.data[temp] || {})
            this.comm[temp] = setting['comm'] || ''
            this.share[temp] = setting['share'] || ''

            setting['customize'] = setting['customize'] || {}
            this.staffCustomize[temp] = this.staffCustomize[temp] || []
            for(let staffID in setting['customize']) {
              this.staffCustomize[temp].push({ staff: staffID, comm: setting['customize'][staffID] })
            }
          }

          this.$forceUpdate()
        })
        .catch((err) => {
          this.showLoading = false

          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        })
    },

    save() {
      this.showLoading = true

      let request = {}
      for (let product of this.sections) {
        request[product['sectionID']] = request[product['sectionID']] || {}
        request[product['sectionID']].comm = this.comm[product['sectionID']]
        request[product['sectionID']].share = this.share[product['sectionID']]

        request[product['sectionID']]['customize'] = {}
        for(let item of this.staffCustomize[product['sectionID']]) {
          if (item.staff) {
            request[product['sectionID']]['customize'][item.staff] = item.comm
          }
        }
      }
      for (let product of this.products) {
        request[product['skuID']] = request[product['skuID']] || {}
        request[product['skuID']].comm = this.comm[product['skuID']]
        request[product['skuID']].share = this.share[product['skuID']]
      }

      let url = `https://emerchant.tunai.io/setting2.php/${this.selectedOutlet.text}_TheNailEdge_fixedCommission_product_setting`
      if (window.location.href.includes('localhost') || window.location.href.includes('127.0.0.1')) {
        url = `http://localhost:8080/setting2.php/${this.selectedOutlet.text}_TheNailEdge_fixedCommission_product_setting`
      }

      this.$axios({
        method: 'post',
        url: url,
        // headers: { token: this.$util.getSessionToken() }
        data: request,
      })
        .then((response) => {
          this.showLoading = false

          this.$bvModal.hide('productConfiguration')
          this.$emit('modalClose');
        })
        .catch((err) => {
          this.showLoading = false

          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        })
    },

    sectionShareChange(sectionID) {
      for(let temp of this.selectedProducts) {
        this.share[temp['id']] = this.share[sectionID]
      }
      this.$forceUpdate()
    },

    addCustomize(sectionID) {
      this.staffCustomize[sectionID].push({})
      this.$forceUpdate()
    },

    removeCustomize(sectionID, index) {
      this.staffCustomize[sectionID].splice(index, 1)
      this.$forceUpdate()
    }
  },
  mounted() {
    this.outlets = JSON.parse(this.$store.state.outlets)
    this.selectedOutlet = this.outlets[0]
  }
}
</script>
<style scoped>
.modal-content {
  background: transparent;
  box-shadow: none;
}

.month-picker-input-container {
  width: 100%;
}
</style>